import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import AllProjects from "../components/projects/allProjects";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/projects.css";

const Projects = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "projects");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Projects | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="projects" />
				<div className="content-wrapper">
					<div className="projects-logo-container">
						<div className="projects-logo">
							<Logo width={46} />
						</div>
					</div>
					<div className="projects-container">
						<div className="title projects-title">
							Things I’ve built exploring game development and software architecture.
						</div>

						<div className="subtitle projects-subtitle">
							<p>
								Here you can find a selection of projects I’ve worked on,
								mainly focused on Unity and C#, where I explore gameplay systems,
								tools, and clean, maintainable architectures.
							</p>
							<p>
								Some of these projects are more technically oriented, while others are small playable experiences.
								For additional prototypes, game jam entries, and short experimental games, you can check out my <a href="https://diegorg64.itch.io/" target="_blank" rel="noreferrer">itch.io page</a>,
								where I regularly share smaller projects that didn’t make it into the main portfolio.
							</p>
						</div>

						<div className="projects-list">
							<AllProjects />
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Projects;
